import React from "react";
import { useTranslation } from "react-i18next";
import GoalsService from "../../../../../services/goals/GoalsService";

type Props = {
  goalId: string;
  onGoalDeleted: (goalId: string) => void;
  closeModal: () => void;
};

const OptionsDelete: React.FC<Props> = ({ goalId, onGoalDeleted, closeModal }) => {
  const { t } = useTranslation("global");

  const handleDelete = async () => {
    if (window.confirm(t("buttons.delete_confirm"))) {
      try {
        await GoalsService.deleteGoal(goalId);
        onGoalDeleted(goalId);
        closeModal();
      } catch (error) {
        console.error("Błąd podczas usuwania celu:", error);
      }
    }
  };

  return (
    <div className="center">
      <button onClick={handleDelete} className="buttonDelete">
        {t("buttons.delete")}
      </button>
    </div>
  );
};

export default OptionsDelete;
